// Akis-ozel etiket query/mutations. Her akisin kendi etiket seti vardir
// (flow_id UNIQUE isim), etiketler baska akislarda gorunmez.

export const GET_FLOW_TAGS = `
  query GetFlowTags($flowId: Int!) {
    report_flow_tags(
      where: { flow_id: { _eq: $flowId } }
      order_by: { name: asc }
    ) {
      id
      flow_id
      name
      color
      created_at
      updated_at
    }
  }
`;

// Bir akistaki tum kart-etiket eslesmelerini item.id -> [tag] halinde
// cekmek icin. Ayni istekle taglari ve iliskileri getirir.
export const GET_FLOW_ITEM_TAGS = `
  query GetFlowItemTags($flowId: Int!) {
    report_flow_item_tags(
      where: { tag: { flow_id: { _eq: $flowId } } }
    ) {
      id
      item_id
      tag_id
      tag {
        id
        name
        color
      }
    }
  }
`;
